import {
  buildMarketingMetadata,
  buildMarketingOpenGraph,
  buildMarketingTwitter,
} from "@/lib/marketing-seo";
import type { Metadata } from "next";

/** Product screenshot used as Open Graph / Twitter image on careers routes. */
export const CAREERS_OG_IMAGE_PATH: string =
  "/marketing/careers/ki-software-hausverwaltung-inbox.png";

export const CAREERS_OG_IMAGE_ALT: string =
  "Hausverwaltung Software: Vorgangssystem und Inbox in hausverwalter.ai";

export const CAREERS_PAGE_TITLE: string =
  "Karriere — Hausverwaltung Software | hausverwalter.ai";

export const CAREERS_PAGE_DESCRIPTION: string =
  "Karriere bei hausverwalter.ai: Hausverwaltung Software mit Vorgangssystem, Buchhaltung, Kundenportal, DMS, Online-Eigentümerversammlung, Telefonanlage, Übergabeformular und KI-Agenten. Jobs in Worms, 2 Tage Homeoffice.";

export const ENGINEERING_PAGE_TITLE: string =
  "Engineering Jobs — Hausverwaltung KI, KI-Agenten & DMS | hausverwalter.ai";

export const ENGINEERING_PAGE_DESCRIPTION: string =
  "Engineering bei hausverwalter.ai: Hausverwaltung KI, KI-Agenten, Dokumentenmanagement, DMS, Vorgangssystem, ETV-Software und Kundenportal. Offene Entwicklerstellen in Worms, 2 Tage Homeoffice.";

export const CAREERS_INBOX_ALT: string =
  "Hausverwaltung Software: Vorgangssystem und Inbox in der hausverwalter.ai Desktop-App";
export const CAREERS_INBOX_TITLE: string =
  "Hausverwaltung Vorgangssystem — Inbox";

export const CAREERS_MOBILE_ALT: string =
  "Hausverwaltung Buchhaltungssoftware und Aufgaben in der hausverwalter.ai App";
export const CAREERS_MOBILE_TITLE: string =
  "Hausverwaltung Buchhaltungssoftware — Mobile App";

export const CAREERS_WHATSAPP_ALT: string =
  "KI-Agenten Hausverwaltung beantworten Mieteranfragen per WhatsApp";
export const CAREERS_WHATSAPP_TITLE: string =
  "KI-Agenten Hausverwaltung — WhatsApp";

export const CAREERS_CALL_ALT: string =
  "Telefonanlage Hausverwaltung: KI-Agent führt Telefonat mit Eigentümerin";
export const CAREERS_CALL_TITLE: string =
  "Telefonanlage Hausverwaltung — KI-Agent";

export const CAREERS_OFFICE_ALT: string =
  "Team von hausverwalter.ai in Worms — Entwickler der Hausverwaltung Software";
export const CAREERS_OFFICE_TITLE: string =
  "Hausverwaltung Software — Standort Worms";

export const CAREERS_GERMANY_FLAG_ALT: string =
  "Hausverwaltungssoftware Deutschland — hausverwalter.ai, Standort Worms";
export const CAREERS_GERMANY_FLAG_TITLE: string =
  "Hausverwaltungssoftware Deutschland";

export const ENGINEERING_STACK_EMBED_TITLE: string =
  "Hausverwaltung Software Architektur: KI-Agenten, DMS, Vorgangssystem und ETV-Software";

export const CAREERS_PORTRAIT_TITLE: string =
  "Jonathan Tausendfreund, CEO von hausverwalter.ai";

/** Marketing metadata plus the careers product screenshot for social shares. */
export function buildCareersMarketingMetadata(
  title: string,
  description: string,
): Metadata {
  return {
    ...buildMarketingMetadata(title, description),
    openGraph: {
      ...buildMarketingOpenGraph(title, description),
      images: [
        {
          url: CAREERS_OG_IMAGE_PATH,
          alt: CAREERS_OG_IMAGE_ALT,
        },
      ],
    },
    twitter: {
      ...buildMarketingTwitter(title, description),
      images: [CAREERS_OG_IMAGE_PATH],
    },
  };
}
